import { useNotificationsStore } from '@/stores/notifications/notifications.store';

export default function conversationAssigned(data: any): void {
  const notificationsStore = useNotificationsStore();

  // Always play the sound in assigned event
  notificationsStore.setPlayNotificationAudio(true);

  // I'm not the assigned user → play sound notification only
  if (data?.data?.meta?.isSoundNotification) {
    notificationsStore.setIsAssignee(false);
  } else {
    notificationsStore.increaseNotificationsNumber();
    // Only set to true if it was previously false to avoid unnecessary updates
    if (!notificationsStore.isAssignee) {
      notificationsStore.setIsAssignee(true);
    }
  }
}
